var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-list-group',{attrs:{"no-action":"","sub-group":_vm.subGroup},scopedSlots:_vm._u([{key:"activator",fn:function(){return [_c('v-list-item-icon',[(_vm.hasMdi)?_c('v-icon',[_vm._v(" "+_vm._s(_vm.icon)+" ")]):_vm._t("icon")],2),_c('v-list-item-content',[_c('v-list-item-title',[_vm._v(_vm._s(_vm.title))])],1)]},proxy:true}])},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }